import { Component } from '@angular/core';
import { MatchBaseComponent } from '../match-base/match-base.component';
import { MatchRoutePaths } from '@lib-modules/match/match-route-paths';

@Component({
  selector: 'lib-match-widget',
  templateUrl: './match-widget.component.html',
  styleUrls: ['../match-base/match-base.component.scss', './match-widget.component.scss'],
})
export class MatchWidgetComponent extends MatchBaseComponent {

  // Abstract property implementations
  protected subscribeToRouteParams() {
    if (!this.hasInputParams) {
      this.route.paramMap.subscribe(async (paramMap) => {
        const eventId = paramMap.get('eventId');
        const teamId = paramMap.get('teamId');
        if (this.eventId === eventId) {
          return;
        }
        await this.reload(eventId, teamId);
      });
    }
  }

  onNavigateToDetail(): void {
    const fullUrl = `${window.location.origin}/match/${this.matchService.match._id}`;
    window.open(fullUrl, '_blank');
  }
}
